import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter } from 'react-router-dom';
import { App } from './App';
import { AdminAuthProvider } from './auth/AdminAuthProvider';
import { loadRuntimeConfig } from './config/runtime-config';
import '@shared/design-system/tokens.css';
import './styles/global.css';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      // Shorter than the support console's 15s. Every read on this
      // console is a lifecycle judgement -- "is this site actually on
      // the bus?" -- and a stale answer to that question is what the
      // whole app exists to prevent.
      staleTime: 5_000,
      refetchOnWindowFocus: true,
    },
  },
});

async function bootstrap() {
  const rootEl = document.getElementById('root');
  if (!rootEl) throw new Error('Root element #root not found in document.');

  try {
    await loadRuntimeConfig();
  } catch (err) {
    createRoot(rootEl).render(
      <div role="alert" style={{ padding: 24, fontFamily: 'monospace' }}>
        <h1>Configuration error</h1>
        <p>{err instanceof Error ? err.message : String(err)}</p>
      </div>,
    );
    return;
  }

  createRoot(rootEl).render(
    <StrictMode>
      <QueryClientProvider client={queryClient}>
        <BrowserRouter>
          <AdminAuthProvider>
            <App />
          </AdminAuthProvider>
        </BrowserRouter>
      </QueryClientProvider>
    </StrictMode>,
  );
}

void bootstrap();
